const actionTypes = {
  GET_ACADEMIC_YEARS: 'getAcademicYears',
  GET_MONTHS: 'getMonths',
  GET_CENTERS: 'getCenters',
  GET_PROVIDERS: 'getProvider',
  GET_PROVIDERS_SERVICE_TYPE: 'getProviderServiceType',
  GET_STATUS: 'getStatus',
  GET_BILLING_SERVICE_DETAILS: 'getBillingServiceDetails',
  GET_VISIT_DETAILS: 'getVisitDetails',
  GET_BILLING_ADDITIONAL_INFO: 'getBillingAdditionalInfo',
  GET_BILLING_VISIT_CERT_DOCUMENT_TYPES: 'getBillingVisitCertDocumentTypes',
  UPLOAD_VISIT_CERT_DOCUMENT: 'uploadVisitCertDocument',
  GET_BILLING_ADJUSTMENTS_DETAILS: 'getBillingAdjustmentsDetails',
  GET_BILLING_STATUS_TRANSITION: 'getBillingStatusTransition',
  GET_BILLING_DETAILS_SERVICE_TYPE: 'getBillingDetailsServiceType',
  GET_BILLING_DETAILS_DISCIPLINE: 'getBillingDetailsDiscipline',
  GET_BILLING_DETAILS_SPECIALIST: 'getBillingDetailsSpecialist',
  CHECK_UNCHECK_FLAG_SERVICE_DETAIL: 'checkUncheckFlagServiceDetail',
  GET_BILLING_TRACKING: 'getBillingTracking',
  GET_BILLING_ADJUSTMENTS_DETAILS_LIST: 'getBillingAdjustmentsDetailsList',
  GET_BILLING_SERVICE_ADJUSTMENTS: 'getBillingServiceAdjustments',
  GET_REASONS: 'getReasons',
  SAVE_ADJUSTMENT: 'saveAdjustment',
  GET_SERVICE_TYPES: 'getServiceTypes',
  GET_INTERVENTORS: 'getInterventors',
};

export default actionTypes;
